import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
    const navigate = useNavigate();
    const { handleOAuthCallback } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processCallback = async () => {
            try {
                // Extract session_id from URL hash
                const hash = window.location.hash;
                const sessionIdMatch = hash.match(/session_id=([^&]+)/);

                if (!sessionIdMatch) {
                    console.error("No session_id found in URL");
                    navigate("/login");
                    return;
                }

                const sessionId = sessionIdMatch[1];
                await handleOAuthCallback(sessionId);

                // Clean URL and redirect
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/dashboard", { replace: true });
            } catch (error) {
                console.error("OAuth callback error:", error);
                navigate("/login");
            }
        };

        processCallback();
    }, [handleOAuthCallback, navigate]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center" data-testid="auth-callback">
            <div className="text-center">
                <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
                <p className="text-muted-foreground">Connexion en cours...</p>
            </div>
        </div>
    );
};
